import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Stack,
  Container,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Box,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const navLinks = [
    { label: "Home", to: "/" },
    { label: "Subjects", to: "/subjects" },
    { label: "Pricing", to: "/pricing" },
    { label: "FAQ", to: "/faq" },
    { label: "Blog", to: "/blog" },
    { label: "Contact", to: "/contact" },
  ];

  const handleNavigate = (to) => {
    setOpen(false);
    navigate(to);
  };

  return (
    <>
      {/* APP BAR */}
      <AppBar position="sticky" color="inherit" elevation={0}>
        <Container maxWidth="lg">
          <Toolbar sx={{ minHeight: 64, px: { xs: 1, sm: 2 } }}>
            
            {/* MOBILE MENU ICON (LEFT) */}
            <IconButton
              edge="start"
              onClick={() => setOpen(true)}
              sx={{ display: { md: "none" }, mr: 1 }}
            >
              <MenuIcon />
            </IconButton>

            {/* LOGO */}
            <Typography
              component={Link}
              to="/"
              sx={{
                textDecoration: "none",
                fontWeight: 800,
                color: "black",
                fontSize: "1.2rem",
              }}
            >
              CBT <span style={{ color: "#1976d2" }}>Nova</span>
            </Typography>

            {/* DESKTOP NAV LINKS */}
            <Stack
              direction="row"
              spacing={3}
              sx={{
                ml: 4,
                display: { xs: "none", md: "flex" },
              }}
            >
              {navLinks.map((l) => (
                <Link
                  key={l.to}
                  to={l.to}
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                    fontWeight: 500,
                  }}
                >
                  {l.label}
                </Link>
              ))}
            </Stack>

            {/* DESKTOP ACTIONS */}
            <Stack
              direction="row"
              spacing={1}
              sx={{
                ml: "auto",
                display: { xs: "none", md: "flex" },
              }}
            >
              <Button component={Link} to="/login">
                Login
              </Button>
              <Button
                variant="contained"
                component={Link}
                to="/register"
              >
                Register
              </Button>
            </Stack>
          </Toolbar>
        </Container>
      </AppBar>

      {/* LEFT DRAWER */}
      <Drawer
        anchor="left"
        open={open}
        onClose={() => setOpen(false)}
        PaperProps={{
          sx: {
            width: 260,
            pt: 2,
          },
        }}
      >
        {/* DRAWER HEADER */}
        <Box sx={{ px: 2, pb: 1 }}>
          <Typography fontWeight={800} fontSize="1.1rem">
            CBT <span style={{ color: "#1976d2" }}>Nova</span>
          </Typography>
        </Box>

        {/* DRAWER LINKS */}
        <List>
          {navLinks.map((l) => (
            <ListItem
              button
              key={l.to}
              onClick={() => handleNavigate(l.to)}
            >
              <ListItemText primary={l.label} />
            </ListItem>
          ))}

          {/* DIVIDER ACTIONS */}
          <Box sx={{ mt: 2 }}>
            <ListItem button onClick={() => handleNavigate("/login")}>
              <ListItemText primary="Login" />
            </ListItem>
            <ListItem button onClick={() => handleNavigate("/register")}>
              <ListItemText primary="Register" />
            </ListItem>
          </Box>
        </List>
      </Drawer>
    </>
  );
}
